import initReactApp from 'dpl/util/initReactApp';
import FooterNewsletterForm from 'dpl/components/FooterNewsletterForm';

initReactApp({
  FooterNewsletterForm
});
